import React,{useState} from 'react';
import { Box, TextField, Grid, Button, Typography, Link, OutlinedInput, InputAdornment } from '@material-ui/core';
import { useFormik } from "formik";
import { VisibilityOutlined, VisibilityOffOutlined, AlternateEmail } from "@material-ui/icons";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import Lock from 'images/Lock.svg';
import FormattedMessage from "features/common/TranslatedMessage";
import * as Yup from "yup";
import {setLogOut,
  setTokenAsync
} from "slices/loginSlice";
import { Alert } from "@material-ui/lab";
import tdsatIcon from "images/TDSAT_Logo_Golden.svg";
import { getGuidelineForEFiling } from 'features/Tdsat/API/TdsatApi';
import fileDownload from 'js-file-download';
import UserIcon from 'images/User.svg';
import DividerWithText from 'features/Divider/DividerWithText';
import tdsatLogo from 'images/TDSAT_Logo.svg';
import WebnyayLogo from 'images/webnyay.svg';

const LoginSchema = Yup.object().shape({
  email: Yup.string().trim()
  .required("Email or Phone number is required")
  .test("is-email-or-phone", "Enter a valid email or 10-digit phone number", (value) => {
    if (!value) return false;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^\d{10}$/;
    return emailRegex.test(value.trim()) || phoneRegex.test(value.trim());
  }),
  password: Yup.string().required("Password Required"),
});

const LoginTdsat = ({setCurrentStep}) => {
  const history = useHistory();

  const dispatch = useDispatch();

  const { state: routeState } = useLocation();
  const [currentScreen, setCurrentScreen] = useState(1);
  const apiErrors = useSelector((state) => state.login.errors);
  const hasErrors = useSelector((state) => state.login.hasErrors);
  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: LoginSchema,
    onSubmit: (values) => {
      dispatch(setLogOut());
      let { email, password } = values;
      dispatch(setTokenAsync(email, password)).then(() => {
        if (routeState) {
          history.push(`${routeState.from.pathname}`);
        } else {
          history.push("/");
        }
      });
    },
  });

  const [passwordType, setPasswordType] = useState("password");
  const tooglePasswordType = () => {
    if (passwordType === "password") {
      setPasswordType("text");
    } else {
      setPasswordType("password");
    }
  };

  React.useEffect(() => {
    dispatch(setLogOut());
  }, []);

  const downloadGuideline = () => {
    getGuidelineForEFiling().then((res)=>{
      fileDownload(
        res.data,
        `Guideline for E-filing.pdf`
      );
    }).catch((error)=>{
      console.log(error);
    })
  }


  return (
    <>
      <div style={{ width: 175, padding: '1rem'}}>
        <img src={tdsatLogo} alt="TDSAT Logo"  width={'100%'}/>
      </div>
      <Typography variant="h5" component="h1" style={{fontSize:'2.5rem'}}>
        E-Filing Portal
      </Typography>
      <form onSubmit={formik.handleSubmit} style={{width:'35%'}}>
        <Box mt={2} width="100%">
          <Box mt={6} textAlign="center">
            <Typography style={{marginBottom:'8px'}}>
              {"Are you a new user?"}
            </Typography>
            <Button variant='contained' fullWidth color='primary' style={{textTransform:'uppercase'}} onClick={() => setCurrentStep('signUp')}>Sign up</Button>
          </Box>
          <DividerWithText>
            <Typography style={{color:'black', margin:'1.25rem 0'}}>OR</Typography>
          </DividerWithText>
          <Typography id="email">Email or Phone number</Typography> 
          <OutlinedInput
            margin="normal"
            fullWidth
            value={formik.email}
            required
            id="email"
            name="email"
            autoComplete="email"
            placeholder="Type email address or Phone number"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            startAdornment={<InputAdornment position="start" style={{color:'#5a5a5a'}}><img src={UserIcon} alt=''/></InputAdornment>}
          />
          {formik.errors.email && formik.touched.email && (
            <Box display="flex" alignItems="center" color='#DC362E' mt={0.5} fontSize={'14px'}>
              <Typography>{formik.errors.email}</Typography>
            </Box>
          )}
          {hasErrors && apiErrors.email && (
            <Box display="flex" alignItems="center" color='#DC362E' mt={0.5} fontSize={'14px'}>
              <Typography>{apiErrors.email[0]}</Typography>
            </Box>
          )}
          <Box mt={1}/>
          <Typography id="password" ><FormattedMessage id="auth.password" /></Typography>
          <OutlinedInput
            fullWidth
            margin="normal"
            required
            name="password"
            type={passwordType}
            id="password"
            value={formik.password}
            autoComplete="current-password"
            placeholder="At least 6 characters"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            startAdornment={<InputAdornment position="start"><img src={Lock} alt="Lock" /></InputAdornment>}
            endAdornment={
              <InputAdornment
                position="end"
                onClick={tooglePasswordType}
                style={{ cursor: "pointer", color: '#5a5a5a' }}
              >
                {passwordType === "password" ? (
                  <VisibilityOffOutlined />
                ) : (
                  <VisibilityOutlined />
                )}
              </InputAdornment>
            }
          />
          {formik.errors.password && formik.touched.password && (
            <Box display="flex" alignItems="center" color='#DC362E' mt={0.5} fontSize={'14px'}>
              <Typography>{formik.errors.password}</Typography>
            </Box>
          )}
          {hasErrors && apiErrors.password && (
            <Box display="flex" alignItems="center" color='#DC362E' mt={0.5} fontSize={'14px'}>
              <Typography>{apiErrors.password[0]}</Typography>
            </Box>
          )}
          <Box display="flex" justifyContent="flex-end" alignItems="center" color='#DC362E' mt={0.5} mb={2} fontSize={'14px'} fontWeight={700}>
            <Typography 
              onClick={() => setCurrentStep('forgotPassword')} 
              style={{ cursor: 'pointer', color: 'darkgray', fontSize: '0.875rem' }}
            >
              Forgot password?
            </Typography>
          </Box>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            sx={{ marginTop: 2 }}
            onClick={formik.handleSubmit}
          >
            LOG IN
          </Button>
          {hasErrors && apiErrors.non_field_errors && (
            <Alert severity="error">{apiErrors.non_field_errors[0]}</Alert>
          )}
          <div style={{height:'2rem'}} />
          <div style={{marginTop:'2rem'}}>
            {/* <Typography style={{textDecoration:'underline', cursor:'pointer', textAlign:'center', fontSize:'12px'}} 
              onClick={downloadGuideline}
            >
              Download the Guidelines for E-filing
            </Typography> */}
          <Typography style={{textAlign:'center'}} 
          >
            Designed and developed by
          </Typography>
          <div style={{width:'120px', margin:'auto', padding: '0.5rem 1rem'}}>
            <img src={WebnyayLogo} alt="TDSAT Logo"  width={'100%'}/>
          </div>
          </div>
        </Box>
      </form>
    </>
  );
}

export default LoginTdsat;
